import { useCartState } from '../contexts/cart/cartContext';
import { useFilterState } from '../components/cap';
import useCartEstimate from '../components/App/hooks/useCartEstimate';
import { getCartDetails, removeMultipleUnavailableItems, replaceCartItemWithSimilarItem, updateCartItem, updateLocalCartItem } from '../aem-core-components/actions/cart';
import { SET_UPDATED_EQUIPMENT } from '../aem-core-components/actions/constants';
import { STORAGE_CONFIG } from '../constants/storageConfig';

const useCartOptions = ({ updateCartItemMutation, cartDetailsQuery, handleATPCart, replaceCartItemMutation }) => {
    const [{ editItem, cartId, editQuote, cart }, dispatch] = useCartState();
    const [, filterDispatch] = useFilterState();
    const [{ getEstimates }] = useCartEstimate();
    
    const updateCart = async newQuantity => {
        dispatch({ type: 'beginLoading' });       
        await updateCartItem({
            cartDetailsQuery,
            updateCartItemMutation,
            cartId,
            cartItemUid: editItem.uid,
            itemQuantity: newQuantity,
            handleATPCart,
            dispatch
        });
        dispatch({ type: 'endLoading' });
    };

    const updateCartFromMinicart = async cartItems => {
        dispatch({ type: 'beginLoading' });
        const updatedItems = await updateCartItem({
            cartDetailsQuery,
            updateCartItemMutation,
            cartId,
            cartItems,
            handleATPCart,
            dispatch,
            cart
        });
        dispatch({ type: 'endLoading' });
        return updatedItems;
    };

    const updateLocalCart = async (cartItems, productId) => {
        dispatch({ type: 'beginLoading' });
        await updateLocalCartItem({
            cartDetailsQuery,
            updateCartItemMutation,
            cartId,
            cartItems,
            dispatch,
            productId
        });
        dispatch({ type: 'endLoading' });
    };

    const replaceCartItem = async (unavailableItemSku, similarItemsData) => {
        dispatch({ type: 'beginLoading' });
        const updatedItems = await replaceCartItemWithSimilarItem({
            replaceCartItemMutation,
            cartId,
            handleATPCart,
            dispatch,
            cart,
            unavailableItemSku,
            similarItemsData
        });
        dispatch({ type: 'endLoading' });
        return updatedItems;
    }

    const updateCartOnEditQuote = async () => {
        dispatch({ type: 'beginLoading' });
        await updateCartItem({
            cartDetailsQuery,
            updateCartItemMutation,
            cartId,
            cartItems: editQuote?.updatedEquipmentData,
            dispatch
        });
        dispatch({ type: SET_UPDATED_EQUIPMENT, isUpdateAvailable: false, payload: {} });
        getEstimates();
        dispatch({ type: 'endLoading' });
    };

    const removeUnavailableItems = async (unavailableItems, showLoader = true, cart) => {
        let items = unavailableItems?.map(item => {
            return { cart_item_uid: item?.uid, quantity: 0 };
        });
        await updateCartForUnavailableItems(items, showLoader, cart);
    };

    const updateCartForUnavailableItems = async (cartItems, showLoader, cart) => {
        showLoader && dispatch({ type: 'beginLoading' });
        await removeMultipleUnavailableItems({
            cartDetailsQuery,
            updateCartItemMutation,
            cartId,
            cartItems,
            handleATPCart,
            dispatch,
            cart
        })

        showLoader && dispatch({ type: 'endLoading' });
    };

    const getProductDataFromCart = async () => {
        let localAssets = JSON.parse(sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.LOCAL_ASSETS_DATA) || '[]');
        const cartQty = localStorage.getItem(STORAGE_CONFIG.LOCAL_STORAGE.CARTTOTALQUANTITY);
        if (cartId && cartQty > 0 && !localAssets?.length) {
            /**
             * if cart id is present and cart qty is present in storage
             * but local assets are not present,
             * then calling api to fetch cart and create local assets
             **/
            await getCartDetails({
                cartDetailsQuery,
                dispatch,
                cartId,
                filterDispatch,
                handleATPCart
            });
            /** fetching local assets again after calling cart api */
            localAssets = JSON.parse(sessionStorage.getItem(STORAGE_CONFIG.SESSION_STORAGE.LOCAL_ASSETS_DATA) || '[]');
        }
        return localAssets;
    };

    const data = { editItem, cartId };
    const api = {
        dispatch,
        updateCartItem: updateCart,
        updateCartFromMinicart,
        updateCartForUnavailableItems,
        updateCartOnEditQuote,
        removeUnavailableItems,
        replaceCartItem,
        updateLocalCart,
        getProductDataFromCart
    };
    return [data, api];
};

export default useCartOptions;
